import { ErrorTypeClass } from "./models/errorFormat"
import { ItemActionHandler } from "./../erm-vue/src/misc/IMenuItem"
import { colorPaletteEntry } from "./models/riskMatrixCell"

import { createApp } from "vue"

import "./index.css"
import "./tailwindlayer.css"
// import "./flags.css"
import "./crispify/crispy.css/"
import "./crispify/erm-brand.css/"
import "./crispify/primevue-overrides.css/"
import "./crispify/variables.css/"
import "./assets/styles/demo-tour.css"

// import "primevue/resources/themes/saga-blue/theme.css" // old basic theme

// PrimeVue 4 doesn't need core CSS - styling is handled by the theme preset
import "primeicons/primeicons.css" //icons

// import "vue-json-pretty/lib/styles.css"

import router from "./components/router"
import PrimeVue from "primevue/config"

import ToastService from "primevue/toastservice"
import Toast from "primevue/toast"
import Select from "primevue/select"
import BaseTooltip from "primevue/tooltip"
import ConfirmationService from "primevue/confirmationservice"
import PageLabel from "./components/pageLabel.vue"
import SubHeader from "./components/subHeader.vue"
import ProgressBar from "primevue/progressbar"
import CardHeader from "./crispify/crispy-components/CardHeader.vue"
import FormCard from "./crispify/crispy-components/FormCard.vue"
import I2FormField from "./crispify/crispy-components/I2FormField.vue"
import I2Label from "./crispify/crispy-components/I2Label.vue"
import I2FormFooter from "./crispify/crispy-components/I2FormFooter.vue"
import I2FormRow from "./crispify/crispy-components/I2FormRow.vue"
import TableHeader from "./crispify/crispy-components/TableHeader.vue"
import { autoAnimatePlugin } from "@formkit/auto-animate/vue"

// Import AG Grid styles and modules
import { AllEnterpriseModule, LicenseManager, ModuleRegistry } from "ag-grid-enterprise"
ModuleRegistry.registerModules([AllEnterpriseModule])
LicenseManager.setLicenseKey(
	"Using_this_{AG_Grid}_Enterprise_key_{AG-091421}_in_excess_of_the_licence_granted_is_not_permitted___Please_report_misuse_to_legal@ag-grid.com___For_help_with_changing_this_key_please_contact_info@ag-grid.com___{ERM}_is_granted_a_{Multiple_Applications}_Developer_License_for_{4}_Front-End_JavaScript_developers___All_Front-End_JavaScript_developers_need_to_be_licensed_in_addition_to_the_ones_working_with_{AG_Grid}_Enterprise___This_key_has_been_granted_a_Deployment_License_Add-on_for_{5}_Production_Environments___This_key_works_with_{AG_Grid}_Enterprise_versions_released_before_{14_July_2026}____[v3]_[01]_MTc4Mzk4MzYwMDAwMA==fe6cc0cfe495e780b5f769ca79479290"
)

import { createPinia } from "pinia"
import App from "./App.vue"

//import Vue from "vue-azure-maps/node_modules/vue/types/umd"
import VueJsonPretty from "vue-json-pretty"

import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome"
import { library } from "@fortawesome/fontawesome-svg-core"
import {
	faCircleLeft,
	faCircleInfo,
	faChevronsRight,
	faChevronsLeft,
	faFileLines,
	faFlask,
	faFlaskGear,
	faSackXmark,
	faSquarePollVertical,
	faArrowsSpin,
	faBoxesPacking,
	faFlaskRoundPotion,
	faInfoCircle,
	faTrash,
	faPen,
	faFloppyDisk,
	faXmarkLarge,
	faPlus,
} from "@fortawesome/pro-regular-svg-icons"

import { faShare, faLightbulbOn, faXmark, faBold, faBottleWater, faShower, faTruckDroplet, faPersonSwimming, faFireBurner, faCarSide, faPlane, faLeaf, faWeightHanging, faDroplet, faPalletBoxes, faGaugeHigh, faFileLines as faFileLinesSolid, faHandHoldingSeedling, faTriangleExclamation } from "@fortawesome/pro-solid-svg-icons"
library.add(
	faCircleLeft,
	faCircleInfo,
	faShare,
	faChevronsRight,
	faChevronsLeft,
	faFileLines,
	faFlask,
	faFlaskGear,
	faLightbulbOn,
	faSackXmark,
	faSquarePollVertical,
	faArrowsSpin,
	faBoxesPacking,
	faFlaskRoundPotion,
	faInfoCircle,
	faTrash,
	faPen,
	faFloppyDisk,
	faXmarkLarge,
	faPlus,
	faXmark,
	faBold,
	faBottleWater,
	faShower,
	faTruckDroplet,
	faPersonSwimming,
	faFireBurner,
	faCarSide,
	faPlane,
	faLeaf,
	faWeightHanging,
	faDroplet,
	faPalletBoxes,
	faGaugeHigh,
	faFileLinesSolid,
	faHandHoldingSeedling,
	faTriangleExclamation
)

import OktaVue from "@okta/okta-vue"
import { oktaAuth } from "./auth/oktaAuth"
import ConfirmDialog from "primevue/confirmdialog"

// import { text } from "stream/consumers"

import { basePreset } from "./theme/global.js"
import { useThemeManagerStore } from "@/store/themeManagerStore"
import { useHelpLabelStore } from "@/store/helpLabelStore"
import { method } from "lodash"
import { findSingle, hasClass } from "@primevue/core/utils"
import Dialog from "primevue/dialog"
import { loadEnvironmentBadge } from "./composables/environmentSettings"
import { rememberOriginalUriWithOkta, rememberPostLoginPath } from "./auth/postLoginRedirect"

// The address the browser was opened with, written down as this module is evaluated — before the
// application starts, and before anything can navigate away from it.
//
// A link from an email points at one particular page, a support request usually, and reaching it
// while signed out sends the browser to the identity provider, which comes back on /login/callback
// with no memory of where it was going. Two earlier placements were not early enough:
//
//   * a route guard: reading the session (SessionInfo.currentUser()) starts the redirect by
//     itself, and components do that during start-up, before the router resolves anything;
//   * the first line of init(): it sits behind `await loadEnvironmentBadge()`, and a redirect
//     fired while that call is in flight leaves the rest of init() unreachable.
//
// Here nothing precedes it, and no await stands in the way.
rememberPostLoginPath(window.location.pathname + window.location.search)

// The same address handed to the Okta SDK, which carries it through its own login transaction.
// Two channels for one destination is not belt and braces for its own sake: the storage above has
// been cleared out from under this flow more than once — by signing out, by the token manager, by
// another tab — and this one travels by a different route entirely.
rememberOriginalUriWithOkta(window.location.pathname + window.location.search)

async function init() {
	await loadEnvironmentBadge()

	if (!sessionStorage.getItem("targetRoute")) {
		sessionStorage.setItem("targetRoute", "/app")
	}

	const app = createApp(App)
	app.config.warnHandler = () => {}
	//app.config.errorHandler = () => {}
	//console.log("ENV:", import.meta.env.VITE_ENVIRONMENT_NAME.toString())
	if (import.meta.env.VITE_ENVIRONMENT_NAME.toString() !== "Development") console.log = function () {}

	app
		//.use(AuthPlugin)
		.use(ConfirmationService)
		.use(router)
		.use(createPinia())

	// Initialize theme store after Pinia is set up and load default theme
	const themeStore = useThemeManagerStore()

	// Load default theme from database
	try {
		await themeStore.initDefaultTemplateFromDB()
	} catch (error) {
		console.warn("Failed to load default theme, using fallback:", error)
		// Continue with the base preset if theme loading fails
	}
	// Initialize help label store (non-blocking — don't await)
	const helpLabelStore = useHelpLabelStore()
	helpLabelStore.loadAll().catch((err) => console.warn("Failed to load help labels:", err))

	const defaultTheme = themeStore.get
	app
	// app
	// 	.use(PrimeVue, {
	// 		ripple: false,
	// 		unstyled: false,
	// 		theme: {
	// 			preset: MyPreset,
	// 		},
	// 		options: {
	// 			darkModeSelector: false,
	// 		},
	// 	})

	// We want to enable tooltips to have custom targetting
	// We extend it here by overriding the getTarget method
	// We have to use any type because extend method is not exposed
	const Tooltip = (BaseTooltip as any).extend({
		methods: {
			getTarget(this: any, el: any): any {
				if (this.$value?.getCustomTarget) {
					const customTarget = this.$value.getCustomTarget(el)
					el.$_ptooltipCustomTarget = customTarget
					return customTarget
				}
				// If a custom target was previously set, keep using it so
				// unbindEvents targets the same element that was originally bound
				if (el.$_ptooltipCustomTarget) {
					return el.$_ptooltipCustomTarget
				}
				return hasClass(el, "p-inputwrapper") ? (findSingle(el, "input") ?? el) : el
			},
		},
	})

	app
		.use(PrimeVue, {
			// Default theme configuration
			theme: {
				preset: themeStore.getCurrentPreset,
				options: {
					prefix: "p",
					darkModeSelector: false,
				},
			},
		})
		.use(ToastService)
		.use(autoAnimatePlugin)
		.use(OktaVue, { oktaAuth })
		.directive("tooltip", Tooltip)
		.component("Toast", Toast)
		.component("Select", Select)
		.component("PageLabel", PageLabel)
		.component("SubHeader", SubHeader)
		.component("ProgressBar", ProgressBar)
		.component("VueJsonPretty", VueJsonPretty)
		.component("FontAwesomeIcon", FontAwesomeIcon)
		.component("CardHeader", CardHeader)
		.component("FormCard", FormCard)
		.component("I2FormField", I2FormField)
		.component("I2Label", I2Label)
		.component("I2FormFooter", I2FormFooter)
		.component("I2FormRow", I2FormRow)
		.component("TableHeader", TableHeader)
		.component("ConfirmDialog", ConfirmDialog)
		.component("Dialog", Dialog)
		.mount("#app")
}

init()
